import { Key } from "../../Data/HexMap/Key";
import { Note } from "../../Data/HexMap/Note";
import { Angles } from "../../Util/Math/Angles";
import { Chords } from "../../Util/Music/Chords";
import './ChordShape.scss'

export function ChordShape(props:{root:number, formula:number[], notes:Note[], parentKey:Key}){
    const sortAndFilterNotes = () => {
        const getChordNotes = () => {
            const positions:number[] = Chords.GetChordPositions(props.root, props.formula)
            const chordNotes:Note[] = positions.map((position:number)=>{
                return(props.notes[position])
            })
            return chordNotes
        }
         const getAngle = (note:Note) => {
            const angle:number = 90 + Angles.getAngleFromPoints(props.parentKey.params.x, props.parentKey.params.y, note.params.x, note.params.y)
            return angle
        }
        const compareAngles = (noteA:Note, noteB:Note) => {
            if(getAngle(noteA) <= getAngle(noteB)){return -1}
            else{return 1}
        } 
        let notes:Note[] = getChordNotes()
        if(notes.length > 3){ // remove the seven if there are more than 3 notes in the chord
            notes = notes.filter((note:Note)=>{return note.params.noteIndex !== 6})
        }
        notes = notes.sort(compareAngles) // sort clockwise by angle relative to key center
        return notes
    }
    const getPoints = () => {
        const points:string[] = []
        const notes:Note[] = sortAndFilterNotes()
        notes.forEach((note:Note)=>{
            points.push(note.getCoordinates().toStringPoints()) 
        })
        return points.join(',')
    }
    return <polygon className={'chord-shape'} points={getPoints()}/>
}